<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranSap="GetPrikljuckiDovoljenja"
                           :selectorPermissions="selectorPermissions" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Mobilna telefonija
          </p>
        </div>
        <div class="postavitev-izbirnika-telefonskih-stevilk">
          <p>
            Izberite številko, na kateri želite spremeniti paket
            <el-select class="izbirnik-telefonskih" v-model="izbranaTelefonska"
                       placeholder="Izberite tel. številko">
              <el-option v-for="data in telefonskeStevilke"
                         :value="data.telefonska_stevilka"
                         :label="VrniFormatiranoTelefonsko(data.telefonska_stevilka, '5')"
                         :key="data.telefonska_stevilka">
              </el-option>
            </el-select>
          </p>
        </div>
        <el-tabs type="border-card" @tab-click="HandleTabClick" :value="activetab" v-if="prikaziPodatkovnePakete">
          <el-tab-pane v-for="(skupina, key) in seznamZavihkov" :key="key"
                       :label="skupina.naziv_skupine"
                       :name="skupina.ref"
                       ref="skupina.ref">
            <div v-if="activetab === skupina.ref">
              <div class="postavitev-mobilna-telefonija" v-loading="nalaganjeMobilnihPaketov">
                <template v-for="posamezenPaket in seznamMoznihStoritev">
                  <div v-if="posamezenPaket.naziv_skupine === skupina.naziv_skupine" class="postavitev-podatkov">
                    <div class="postavitev-naziva">
                      <b>
                        {{ posamezenPaket.naziv.toUpperCase() }}
                      </b>
                    </div>
                    <div class="podcrtan-naziv-mobilna-telefonija"/>
                    <br/>
                    <div class="izpis-opisa-mobilna-telefonija" v-html="posamezenPaket.opis" style="font-size: 14px;">
                    </div>
                    <div class="izpis-cena-mobilna-telefonija">
                      {{ posamezenPaket.cenaSI }} € / mesec
                    </div>
                    <div style="clear: both">
                      <div>
                        <div v-if="posamezenPaket.vklopljeno === 1 && koncanoPridobivanjePodatkov === 1"
                             class="postavitev-gumb-naroceno">
                          <a class="okvir-naroceno tekst-kontaktnih-podatkov">
                            <img src="/static/img/kljukica2.svg" width="12px"
                                 style="vertical-align: middle; margin-right: 8px;" />
                            <b>
                              VKLOPLJENO
                            </b>
                          </a>
                        </div>
                        <OrderButton
                          v-if="posamezenPaket.naroceno === 0 && posamezenPaket.vklopljeno !== 1 && koncanoPridobivanjePodatkov === 1"
                          :disabled="hasAnyPendingOrder"
                          :services="[{serviceId: posamezenPaket.idStoritevVrstaIzbira, quantity: 1, terminationPointId: Number.parseInt(izbranIdPrikljucek)}]"
                          class="postavitev-gumb-narocanje"
                          :service-name="posamezenPaket.naziv"
                          @orderConfirmed="GetSeznamPaketov()"
                        >
                          NAROČI PAKET
                        </OrderButton>
                        <div v-if="posamezenPaket.naroceno === 1 && koncanoPridobivanjePodatkov === 1" class="postavitev-gumb-naroceno">
                          <a class="okvir-narocilo-v-teku tekst-kontaktnih-podatkov">
                            <b>
                              NAROČENO
                            </b>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="postavitev-mobilna-telefonija" v-loading="nalaganjeMobilnihPaketov" v-if="!prikaziPodatkovnePakete">
          <template v-for="posamezenPaket in seznamMoznihStoritev">
            <div v-if="posamezenPaket.naziv_skupine === 'Mobilni paketi'" class="postavitev-podatkov">
              <div class="postavitev-naziva">
                <b>
                  {{ posamezenPaket.naziv.toUpperCase() }}
                </b>
              </div>
              <div class="podcrtan-naziv-mobilna-telefonija"/>
              <br/>
              <div class="izpis-opisa-mobilna-telefonija" v-html=posamezenPaket.opis>
              </div>
              <div class="izpis-cena-mobilna-telefonija">
                {{ posamezenPaket.cenaSI }} € / mesec
              </div>
              <div style="clear: both">
                <div>
                  <div v-if="posamezenPaket.vklopljeno === 1 && koncanoPridobivanjePodatkov === 1"
                       class="postavitev-gumb-naroceno">
                    <a class="okvir-naroceno tekst-kontaktnih-podatkov">
                      <img src="/static/img/kljukica2.svg" width="12px"
                           style="vertical-align: middle; margin-right: 8px;" />
                      <b>
                        VKLOPLJENO
                      </b>
                    </a>
                  </div>
                  <OrderButton
                    v-if="posamezenPaket.naroceno === 0 && posamezenPaket.vklopljeno !== 1 && koncanoPridobivanjePodatkov === 1"
                    :disabled="hasAnyPendingOrder"
                    :services="[{serviceId: posamezenPaket.idStoritevVrstaIzbira, quantity: 1, terminationPointId: Number.parseInt(izbranIdPrikljucek)}]"
                    class="postavitev-gumb-narocanje"
                    :service-name="posamezenPaket.naziv"
                    @orderConfirmed="GetSeznamPaketov()"
                  >
                    NAROČI PAKET
                  </OrderButton>
                  <div v-if="posamezenPaket.naroceno === 1 && koncanoPridobivanjePodatkov === 1" class="postavitev-gumb-naroceno">
                    <a class="okvir-narocilo-v-teku tekst-kontaktnih-podatkov">
                      <b>
                        NAROČENO
                      </b>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <InfoKomponentaMobilnaDelPaketa v-if="podredniPrikljucek"/>
        <OrderExistsInfo v-if="hasAnyPendingOrder"/>
      </div>
    </div>
    <el-dialog
      append-to-body
      :visible.sync="dialogVisibleNarociPaket"
      :width="velikostPrikazaDialoga"
      :show-close="false"
      center>
      <span>
        <div>
          <div class="postevitev-title-img">
            <img src="/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png" style="cursor: pointer"
                 class="icon-dialog">
          </div>
        </div>
        <div style="padding: 50px 40px 0 40px;">
          <div>
            <p style="word-break: break-word; text-align: center; font-size: 15px" class="navadno-besedilo">
              Strinjam se s<a :href="splosniPogojiURL" target="_blank" style="cursor: pointer" class="primarna-barva">
                splošnimi pogoji</a>
              in želim naročiti mobilni paket <b>{{this.izbranPosamezniPaket.naziv}}</b>
            </p>
          </div>
        </div>
      </span>
      <div style="text-align: center; padding-top: 30px; padding-bottom: 20px" class="postevitev-gumob">
        <span slot="footer" class="dialog-footer">
          <el-button class="gumb-brez-obrob krepko crna" @click="dialogVisibleNarociPaket = false">
            Prekliči
          </el-button>
          <el-button type="primary krepko" @click="NarociNovMobilniPaket">
            Da
          </el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ClientAgent from '../../../../assets/js/clientAgent.js'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import {
  Select, Option, Form, Button, Alert, Collapse, CollapseItem,
  Tooltip, Col, Dialog, TabPane, Tabs
} from 'element-ui'
import Vue from 'vue'
import {StoritveOpisFormat} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StoritveOpisFormat'
import {FormatirajTelefonskoStevilko}
  from '../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import InfoKomponentaMobilnaDelPaketa from './InfoKomponentaMobilnaDelPaketa'
import {povezave} from '../../../../assets/js/Povezave/povezave'
import OrderButton from '../../../UIComponents/OrderButton.vue'
import OrderExistsInfo from '../../../UIComponents/OrderExistsInfo.vue'


export default {
  name: 'NarociMobilnaTelefonija',
  mixins: [StringConverter, StoritveOpisFormat, FormatirajTelefonskoStevilko],
  data () {
    return {
      seznamStevilk: [],
      clientAgent: null,
      vklopljenMobilniPaket: null,
      narocenMobilniPaket: null,
      seznamPrikljuckov: [],
      seznamPrikljuckovVsi: [],
      nalaganjeMobilnihPaketov: false,
      izbranaTelefonska: '',
      seznamTelStevilk: [],
      izbranIdPrikljucek: '',
      koncanoPridobivanjePodatkov: 0,
      seznamStrank: [],
      telefonskeStevilke: [],
      selectorPermissions: ['UMTS_TELEFONIJA'],
      aneksKey: 100000,
      podredniPrikljucek: false,
      dialogVisibleNarociPaket: false,
      velikostPrikazaDialoga: '25%',
      izbranPosamezniPaket: '',
      splosniPogojiURL: '',
      seznamMoznihStoritev: [],
      seznamZavihkov: [],
      pogrupiranSeznamStoritev: [],
      activetab: 't1',
      prikaziPodatkovnePakete: false,
      izbranIdPodatkovnegaPaketa: 0
    }
  },
  computed: {
    hasAnyPendingOrder () {
      let out = false
      if (Array.isArray(this.seznamMoznihStoritev)) {
        this.seznamMoznihStoritev.forEach((item) => {
          if (item.naroceno === 1) {
            out = true
          }
        })
      }
      return out
    }
  },
  watch: {
    izbranaTelefonska: function () {
      if (this.izbranaTelefonska !== '') {
        this.PoisciPrikljucekTelefonskeStevilke()
        this.GetSeznamPaketov()
      }
    }
  },
  components: {
    OrderButton,
    OrderExistsInfo,
    InfoKomponentaMobilnaDelPaketa,
    'IzbirnikStranke': IzbirnikStranke,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Alert.name]: Alert,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Col.name]: Col,
    [Tooltip.name]: Tooltip,
    [Dialog.name]: Dialog,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.PrilagodiSirinoDesktopTabele)
    })
    this.splosniPogojiURL = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
  },
  methods: {
    HandleTabClick (tab) {
      this.activetab = tab.name
    },
    PrilagodiSirinoDesktopTabele () {
      if (document.documentElement.clientWidth < 900) {
        this.velikostPrikazaDialoga = '100%'
      }
    },
    PrikaziPotrditvenoOknoZaNarociloStoritve (posamezenPaket) {
      this.dialogVisibleNarociPaket = true
      this.izbranPosamezniPaket = ''
      this.izbranPosamezniPaket = posamezenPaket
    },
    GetPrikljuckiDovoljenja (prenosniSap) {
      if (prenosniSap !== '') {
        let param = ['permissionId=UMTS_TELEFONIJA']
        param.push('filter[sap]=' + prenosniSap)
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          '')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.telefonskeStevilke = []
      this.izbranIdPrikljucek = ''
      this.izbranaTelefonska = ''
      this.seznamStevilk = podatki.permission.additionalData
      if (this.seznamStevilk.length > 0) {
        for (let i = 0; i < this.seznamStevilk.length; i++) {
          this.telefonskeStevilke.push(this.seznamStevilk[i])
          this.izbranaTelefonska = this.seznamStevilk[0].telefonska_stevilka
        }
        this.PoisciPrikljucekTelefonskeStevilke()
      }
    },
    PoisciPrikljucekTelefonskeStevilke () {
      for (let i = 0; i < this.seznamStevilk.length; i++) {
        if (this.seznamStevilk[i].telefonska_stevilka === this.izbranaTelefonska) {
          this.izbranIdPrikljucek = this.seznamStevilk[i].id_prikljucek
        }
      }
    },
    GetSeznamPaketov () {
      this.nalaganjeMobilnihPaketov = true
      this.koncanoPridobivanjePodatkov = 0
      if (this.izbranIdPrikljucek !== '' && this.izbranIdPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranIdPrikljucek]
        param.push('grupiranjeStoritev=1')
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/getNaborTrznihPaketov',
          param,
          null,
          'SetSeznamMobilnihPaketov',
          '')
      }
    },
    SetSeznamMobilnihPaketov (podatki) {
      this.seznamZavihkov = []
      this.seznamMoznihStoritev = []
      this.pogrupiranSeznamStoritev = []
      this.izbranIdPodatkovnegaPaketa = 0
      this.prikaziPodatkovnePakete = false
      for (let i = 0; i < podatki.data.length; i++) {
        if (typeof podatki.data[i].naziv_skupine !== 'undefined') {
          this.seznamMoznihStoritev.push(podatki.data[i])
        }
      }
      this.seznamMoznihStoritev.sort((a, b) =>
        ('naziv_skupine' in a && (('naziv_skupine' in b && a.vrstni_red >= b.vrstni_red) || !('naziv_skupine' in b)))
          ? 1 : -1)
      this.seznamMoznihStoritev.sort((a, b) =>
        ('naziv_skupine' in a &&
          (('naziv_skupine' in b && a.vrstni_red_skupine >= b.vrstni_red_skupine) || !('naziv_skupine' in b)))
          ? 1 : -1)
      for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
        let sviInstanca = this.seznamMoznihStoritev[i]
        Vue.set(sviInstanca, 'naroceno', 0)
        Vue.set(sviInstanca, 'vklopljeno', 0)
        Vue.set(sviInstanca, 'prikazemo', 1)
        if ('hitrosti' in sviInstanca && sviInstanca.hitrosti !== null) {
          for (let j = 0; j < sviInstanca.hitrosti.length; j++) {
            sviInstanca.hitrosti[j].naroceno = 0
            sviInstanca.hitrosti[j].vklopljeno = 0
            Vue.set(sviInstanca.hitrosti[j], 'cenaSI',
              this.PikeVVejice(parseFloat(sviInstanca.hitrosti[j].cena - sviInstanca.cena).toFixed(2)))
          }
        }
        if ('naziv_skupine' in sviInstanca) {
          if (!(sviInstanca.vrstni_red_skupine in this.pogrupiranSeznamStoritev)) {
            this.pogrupiranSeznamStoritev[sviInstanca.vrstni_red_skupine] = []
          }
          sviInstanca.cenaSI = this.PikeVVejice(parseFloat(sviInstanca.cena).toFixed(2))
          this.pogrupiranSeznamStoritev[sviInstanca.vrstni_red_skupine].push(sviInstanca)
        }
      }
      this.seznamZavihkov = []
      let zapsSt = 1
      for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
        let storitev = this.seznamMoznihStoritev[i]
        let seNiVSeznamu = true
        for (let j = 0; j < this.seznamZavihkov.length; j++) {
          if (this.seznamZavihkov[j].vrstni_red_skupine === storitev.vrstni_red_skupine) {
            seNiVSeznamu = false
            break
          }
        }
        if (seNiVSeznamu === true) {
          if (typeof storitev.vrstni_red_skupine !== 'undefined' &&
            typeof storitev.naziv_skupine !== 'undefined') {
            let zavihek = {}
            zavihek.vrstni_red_skupine = storitev.vrstni_red_skupine
            zavihek.naziv_skupine = storitev.naziv_skupine
            zavihek.ref = 't' + zapsSt
            zapsSt++
            this.seznamZavihkov.push(zavihek)
          }
        }
        this.activetab = 't1'
      }
      this.seznamMoznihStoritev = this.OlepsajOpiseStoritev(this.seznamMoznihStoritev)
      this.GetVklopljeneStoritve()
    },
    GetVklopljeneStoritve () {
      if (this.izbranIdPrikljucek !== '') {
        let param = ['idPrikljucek=' + this.izbranIdPrikljucek]
        param.push('idVrsta[]=26')
        param.push('idVrsta[]=19')
        param.push('idStatus=1')
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/info',
          param,
          null,
          'SetTrenutnoVklopljeneStoritve',
          '')
      }
    },
    SetTrenutnoVklopljeneStoritve (podatki) {
      if (podatki.seznamStoritev.length > 0) {
        for (let i = 0; i < podatki.seznamStoritev.length; i++) {
          if (podatki.seznamStoritev[i].idVrsta === 26 || podatki.seznamStoritev[i].idVrsta === 19) {
            this.vklopljenMobilniPaket = podatki.seznamStoritev[i]
            for (let j = 0; j < this.seznamMoznihStoritev.length; j++) {
              if (this.seznamMoznihStoritev[j].idStoritevVrstaIzbira === this.vklopljenMobilniPaket.idStoritev) {
                if (this.seznamMoznihStoritev[j].naziv_skupine === 'Podatkovni paketi') {
                  this.prikaziPodatkovnePakete = true
                  this.izbranIdPodatkovnegaPaketa = this.seznamMoznihStoritev[j].idStoritevVrstaIzbira
                }
                Vue.set(this.seznamMoznihStoritev[j], 'vklopljeno', 1)
              }
              if (this.seznamMoznihStoritev[j].naziv_skupine === 'Podatkovni paketi' &&
                this.seznamMoznihStoritev[j].idStoritevVrstaIzbira !== this.izbranIdPodatkovnegaPaketa) {
                Vue.set(this.seznamMoznihStoritev[j], 'prikazemo', 0)
              }
            }
            break
          }
        }
      }
      this.GetNaroceneStoritve()
    },
    GetNaroceneStoritve () {
      if (this.izbranIdPrikljucek !== '') {
        let param = ['idPrikljucek=' + this.izbranIdPrikljucek]
        param.push('idVrsta[]=26')
        param.push('idVrsta[]=19')
        param.push('idStatus=0')
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/info',
          param,
          null,
          'SetTrenutnoNaroceneStoritve',
          '')
      }
    },
    SetTrenutnoNaroceneStoritve (podatki) {
      this.narocenMobilniPaket = null
      for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
        Vue.set(this.seznamMoznihStoritev[i], 'naroceno', 0)
      }
      if (podatki.seznamStoritev.length > 0) {
        for (let i = 0; i < podatki.seznamStoritev.length; i++) {
          if (podatki.seznamStoritev[i].idVrsta === 26 || podatki.seznamStoritev[i].idVrsta === 19) {
            this.narocenMobilniPaket = podatki.seznamStoritev[i]
          }
        }
        for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
          if (this.seznamMoznihStoritev[i].idStoritevVrstaIzbira === this.narocenMobilniPaket.idStoritev) {
            Vue.set(this.seznamMoznihStoritev[i], 'naroceno', 1)
            break
          }
        }
      }
      this.koncanoPridobivanjePodatkov = 1
      this.nalaganjeMobilnihPaketov = false
    },
    NarociNovMobilniPaket () {
      if (this.izbranIdPrikljucek !== '') {
        if (this.narocenMobilniPaket === null || this.narocenMobilniPaket.idStoritev !== this.izbranPosamezniPaket.idStoritevPaket) {
          let param = []
          param.push('idPrikljucek=' + this.izbranIdPrikljucek)
          param.push('idTrzniPaket=' + this.izbranPosamezniPaket.idStoritevPaket)
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/storitve/narociTrzniPaket',
            param,
            null,
            'SetNarociNovMobilniPaket', '')
        }
      }
    },
    SetNarociNovMobilniPaket () {
      this.GetSeznamPaketov()
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno naročen nov mobilni paket.'
      this.ShowSuccessMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Naroci/NarociMobilnaTelefonija/NarociMobilnaTelefonija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociMobilnaTelefonija.vue